import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicForm({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.5 1.25c1.24 0 2.25 1 2.25 2.25v9c0 1.24-1 2.25-2.25 2.25h-9c-1.24 0-2.25-1-2.25-2.25v-9c0-1.24 1-2.25 2.25-2.25zm0 1.5h-9a.75.75 0 00-.75.75v9c0 .41.34.75.75.75h9c.41 0 .75-.34.75-.75v-9a.75.75 0 00-.75-.75zM8.14 7.98c.26.27.28.69.05.98l-.07.08-1.91 1.84a.75.75 0 01-.97.06l-.08-.08-1.19-1.18a.75.75 0 01.98-1.14l.08.08.67.66 1.38-1.32a.75.75 0 011.06.02zm0-3.7c.26.27.28.69.05.98l-.07.08L6.2 7.18a.75.75 0 01-.97.06l-.08-.08-1.19-1.18a.75.75 0 01.98-1.14l.08.08.67.66 1.38-1.32a.75.75 0 011.06.02zm3.36 1.07a.7.7 0 01.1 1.4H8.9a.7.7 0 01-.1-1.4h2.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicForm.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicForm.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicForm svgRef={ref} {...props} />);
export default ForwardRef;
